import React, { useState } from "react";
import { connect } from "react-redux";
import { loginRequest } from "actions";
import history from "./../history";
import { setCookie } from "helpers/Cookie";

import LoginForm from "components/Forms/LoginForm.js";
import LoginChart from "components/Forms/LoginChart";
import Logo from "i/pickaxe.svg";

window.Buffer = window.Buffer || require("buffer").Buffer;

const LoginPage = (props) => {
  const [loginEmail, setLoginEmail] = useState();

  window.localStorage.setItem(
    "sso_redirect",
    history.location?.state?.nextPathname?.pathname
      ? history.location.state.nextPathname.pathname +
          history.location.state.nextPathname.search +
          history.location.state.nextPathname.hash
      : "/"
  );

  const handleSubmit = ({ email, password }) => {
    if (email && password) {
      const { dispatch } = props;

      const nextPathname =
        props.location &&
        props.location.state &&
        props.location.state.nextPathname;
      // persist the email being used
      setCookie(
        "credential",
        Buffer.from(email.toLowerCase(), "utf8").toString("base64")
      );
      dispatch(loginRequest({ email, password, nextPathname }));
    }
  };

  // Pass email from child form to set initial value
  const passLoginEmail = (email) => setLoginEmail(email);

  return (
    <main className="login">
      <section className="login-left">
        <div className="login-beta">beta</div>
        <div className="login-intro">
          <a href="/" className="mb-5 d-inline-block">
            <img src={Logo} alt="Pickaxe" className="login__logo" />
          </a>
          <h1 className="login-intro__title">
            It's your data. We just make it useful.
          </h1>
        </div>
        <div className="login-copyrights">
          @ {new Date().getFullYear()} Pickaxe Foundry, Inc
        </div>
      </section>
      <section className="login-right">
        <LoginForm
          onSubmit={handleSubmit}
          initialValues={{ email: loginEmail }}
          passLoginEmail={passLoginEmail}
        />
        <LoginChart />
      </section>
    </main>
  );
};

export default connect()(LoginPage);
